import { render } from "./RolesCourse.vue?vue&type=template&id=8e51a5c0"
import script from "./RolesCourse.vue?vue&type=script&lang=js"
export * from "./RolesCourse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__